import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _flatten from 'lodash/flatten';
import _isEmpty from 'lodash/isEmpty';
export function getItems() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    continuous = _ref.continuous,
    items = _ref.items,
    pageSize = _ref.pageSize,
    slide = _ref.slide;
  if (_isEmpty(items)) {
    return [];
  }
  if (slide) {
    // at least 4 items are needed in order to apply the slide effect
    // we also need at least pageSize * 3 items to ensure we have enough element to fill the previous next and current states
    if (items.length < 4 || items.length <= pageSize * 3) {
      return _flatten([].concat(_toConsumableArray(items), _toConsumableArray(items), _toConsumableArray(items))).map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          key: "".concat(item.key, "-").concat(index)
        });
      });
    }
    return items;
  }
  if (continuous) {
    return [].concat(_toConsumableArray(items), _toConsumableArray(items), _toConsumableArray(items));
  }
  return items;
}